import React, { useRef, useState } from "react";
import styled from "styled-components";
import { gql, useLazyQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";

import LoginLayout from "../LoginLayout";
import { TextBtn } from "../../components/inputs/TextBtn";
import { Title } from "../../components/inputs/Title";
import { Desc } from "../../components/inputs/Desc";
import LoginImage from "../../assets/login_images/screen.png";
import { TextInputWTitle } from "../../components/inputs/TextInputWTitle";
const StyleCss = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  .recaptca {
    width: 100%;
  }
`;
const Login_Query = gql`
    query LoginQuery($Mobile: String!){
        loginFirst(Mobile: $Mobile){
            status
            Email
            Mobile
            data
        }
    }
`;

function Login(props) {
  const history = useHistory();

  const [mobile, setMobile] = useState("");
  const [errorText, setError] = useState("");

  const [LoginQuery, loginState] = useLazyQuery(Login_Query, {
    onCompleted: proccessData,
    fetchPolicy: "network-only",
  });

  function proccessData(event) {
    if(event.loginFirst.status){
      history.push("/verify", {
          token: event.loginFirst.data,
          mobile: event.loginFirst.Mobile,
      });
    } else {
        // error
        setError(event.loginFirst.Mobile)
    }
  }

  function sendData() {
    // console.log('here')
    if (mobile.length) {
      LoginQuery({
        variables: {
            Mobile: mobile,
        }
      });
    }
    setError("")
  }
  
  
  onchange = (e) => {
    let value = e.target.value;
    switch (e.target.name) {
        case 'Mobile':
            setMobile(value)
            break;
        default: 
            break;
    }
  }
  return (
    <LoginLayout image={LoginImage}>
      <StyleCss className="data">
        <Title className={"styletext"}>login</Title>
        <Desc className={"styletext"}>
          Enter mobile number for login
        </Desc>
        <div className="spacer-m" />
        <TextInputWTitle
          onEnter={sendData}
          name={"Mobile"}
          value={mobile}
          onchange={onchange}
          error={''}
          title="Mobile number"
        />
        
        <div className="spacer-s" />

        <TextBtn
          type={"button"}
          text={"send code"}
          onclick={sendData}
          loading={loginState.loading}
          disabled={!mobile.length || loginState.loading}
        />
        <div className="spacer-l" />
        <div className="spacer-l" />
      </StyleCss>
    </LoginLayout>
  );
}

export default Login;
